import BackgroundFileResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/BackgroundFilesService/BackgroundFileResponse";

export default class BackgroundFileViewModel {
    id: string;
    name: string;
    constructor(obj?: BackgroundFileResponse) {
        if (obj != null) {
            this.id = obj.Id;
            this.name = obj.Translations[0].Name;
        }
    }
}